














import { Component, Vue, Prop } from 'vue-property-decorator';

import { APP_CONFIG } from '@/config/app-config';

import commonService from '@/services/common-services';

import { Customer } from '@/models/customer';

@Component
export default class ProfileLeft extends Vue {
    @Prop({default: null})
    private customer!: Customer;

    get customerLevels() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].customerLevels;
    }

    get customerLevelsDetail() {
        return (this.customerLevels || []).find((cl) => cl.ID === (this.customer.LevelID || 1));
    }

    private async created() {
        if (!this.customerLevels) {
            await this.getCustomerLevels();
        }
    }

    private async getCustomerLevels() {
        const result = await commonService.getCustomerLevels();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_CUSTOMER_LEVELS', result.data.data);
        }
    }
}
